import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { GenericModalComponent } from '../generic-modal/generic-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { CompletePreApprovalRequest } from 'src/app/models/completeRequest';
import { ProcedurePreApprovalRequestDetails } from 'src/app/models/procedurePreApprovalRequestDetails.model';
import { JobProcedureService } from 'src/app/services/sections/job/job-procedure.service';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { ButtonIcons } from '../action-button/models/button-icons.enum';
import {fadeIn, fadeOut, slideDown, slideUp} from '../../animations';
import { FormControl, FormGroup } from '@angular/forms';
 
@Component({
  selector: 'procedure-pre-approval',
  templateUrl: './procedure-pre-approval.component.html',
  styleUrls: ['./procedure-pre-approval.component.scss', '../job-details/job-details.component.scss', '../stylesheets/job-actions.scss', '../stylesheets/job-main.scss'],
  animations: [slideUp(100), slideDown(100), fadeIn(200), fadeOut(200)]
})
export class ProcedurePreApprovalComponent implements AfterViewInit {

  @ViewChild('procedurePreApprovalResponseModal') public procedurePreApprovalResponseModal: GenericModalComponent;
  @ViewChild('procedurePreApprovalResponseModalError') public procedurePreApprovalResponseModalError: GenericModalComponent;
  @ViewChild('approveProcedurePreApprovalResponseModal') public approveProcedurePreApprovalResponseModal: GenericModalComponent;

  public isLoading = false;
  public self = this;
  public procedurePreApprovalRequestDetails: ProcedurePreApprovalRequestDetails;
  public readonly ButtonIcons = ButtonIcons;
  public approveRequestForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private procedureService: JobProcedureService
  ) {
    this.procedurePreApprovalRequestDetails = this.route.snapshot.data.procedurePreApprovalsDetails as ProcedurePreApprovalRequestDetails;
  }

  ngAfterViewInit(): void {
    GlobalSettingsService.isGlobalLoaderLoading = false;
    GlobalSettingsService.isSecondaryLoaderLoading = false;

    this.approveRequestForm = new FormGroup({
      completionReason: new FormControl(null)
    });
  }

  public navigateWithData(subpage: string): void {
    this.router.navigate([subpage], { relativeTo: this.route, state: { procedurePreApprovalRequestDetails: this.procedurePreApprovalRequestDetails } });
  }

  public onApproveRequest(): void {
    this.approveProcedurePreApprovalResponseModal.open();
  }

  public onCancelApprove(): void {
    this.approveProcedurePreApprovalResponseModal.hide();
    this.approveRequestForm.reset();
  }

  submitApprove(): void {
    this.sendDecision(true, this.approveRequestForm.get('completionReason')?.value);
  }

  submitReject(reason: string): void {
    this.sendDecision(false, reason);
  }

  private sendDecision(isApproved: boolean, completionReason: string | null): void {
    this.approveProcedurePreApprovalResponseModal.hide();
    this.isLoading = true;

    const body: CompletePreApprovalRequest = {
      isApproved,
      completionReason
    };

    this.procedureService
      .updateProcedurePreApprovalRequest(this.route.snapshot.paramMap.get('token')!, body)
      .subscribe(
        () => {
          GlobalSettingsService.isSecondaryLoaderLoading = false;
          this.procedurePreApprovalResponseModal.open();
          this.isLoading = false;
        },
        () => {
          GlobalSettingsService.isSecondaryLoaderLoading = false;
          this.procedurePreApprovalResponseModalError.open();
          this.isLoading = false;
        });
  }

  public closeProcedurePreApprovalResponseModal() {
    this.procedurePreApprovalResponseModal.hide();
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }


}
